






























import { Vue, Prop, Component } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';
import { websiteText } from '@/mixins/websiteTexts';

@Component
export default class CheckboxGroup extends Vue {
    @Prop({ default: () => [] }) options!: TextValuePair[];
    @Prop() label!: string;
    @Prop({ default: false }) formError!: boolean;
    @Prop({ default: 0 }) tabIndex!: number;
    @Prop({ default: false }) isExpandable!: boolean;

    selectedValues: string[] = [];
    expanded: boolean = false;

    get visibleOptions(): TextValuePair[] {
        if (!this.isExpandable || this.expanded || this.options.length <= 3) {
            return this.options;
        }

        return this.options.slice(0, 3);
    }

    websiteText(text: string, extraValues?: string[]) {
        return websiteText(text, extraValues);
    }

    get showExpandButton(): boolean {
        return this.isExpandable && this.options.length > 3;
    }

    toggleExpanded() {
        this.expanded = !this.expanded;
    }

    onChange() {
        const valueToEmit = this.selectedValues.length > 0 ? this.selectedValues.join(', ') : '';
        this.$emit('input', valueToEmit);
        this.$emit('clearError');
    }

    onBlur(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.$emit('blur');
        }
    }
}
